module.exports = __webpack_public_path__ + "static/save-the-cat-71f2cddb21cefdb967d0b938d2b5b025.jpg";